import { render, staticRenderFns } from "./PageLink.vue?vue&type=template&id=7f9dc82f&scoped=true&"
import script from "./PageLink.vue?vue&type=script&lang=js&"
export * from "./PageLink.vue?vue&type=script&lang=js&"
import style0 from "./PageLink.vue?vue&type=style&index=0&id=7f9dc82f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9dc82f",
  null
  
)

export default component.exports